// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"477":"a4483af0","598":"a38683bc","656":"394a9f9a"}[chunkId] + ".chunk.js";
};